// Popup menus built on `<details>` have NO native light-dismiss: clicking away never removes
// the `[open]` attribute, so the menu stays open in the DOM. (For the daisyUI variant it's worse
// than "stays open" — the focus-based daisyUI CSS just drops its opacity, then moving the pointer
// back over the container re-reveals it.) Close any open menu on an outside click or Escape so
// it's genuinely dismissed. FD-573.
//
// Scope note — which `<details>` counts as a MENU:
//
//   A `<details>` is treated as a light-dismissible menu when, and only when, it either
//     (1) carries the daisyUI `dropdown` class — that class IS this app's "I am a popup menu"
//         convention, or
//     (2) carries an explicit `data-menu` attribute — the opt-in marker for the hand-rolled
//         `<details class="relative">` + absolutely-positioned panel menus (page/wiki Export,
//         Move, Publish, Convert…; the dashboard widget menus), which carry no daisyUI class.
//
//   Everything else is a disclosure/accordion — settings sections, sidebar nav groups, the
//   inline "New work item" quick-add row, the lazy comment reply editor, work-item property
//   groups — and is deliberately NOT matched. An accordion must not collapse because you clicked
//   elsewhere on the page (the quick-add row and the reply editor would drop typed input if it
//   did), so don't add `data-menu` to one. Nested `<details>` submenus inside a menu carry
//   neither marker, so they're ignored here and collapse with their parent.
//
//   The div/`tabindex` `.dropdown` variant needs nothing from us: daisyUI drives it purely off
//   `:focus-within`, so it closes itself when focus leaves and has no stuck-open state. Stimulus
//   popup panels (popover, combobox) own their own outside-click + Escape handling.
const MENU_SELECTOR = "details.dropdown[open], details[data-menu][open]"

function closeMenus(except) {
  document.querySelectorAll(MENU_SELECTOR).forEach((menu) => {
    if (except && menu.contains(except)) return // keep the one being interacted with open
    menu.open = false
  })
}

// Capture phase so we settle other open menus before the click's default action (a summary
// toggle / form submit / button_to post / turbo_confirm) runs — mirrors popover_controller's
// outside-click handling. The `contains` guard above is what keeps a click on a menu's own
// <select>, submit button, or link from dismissing that menu mid-interaction.
document.addEventListener("click", (event) => closeMenus(event.target), true)
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeMenus(null)
})

// Turbo caches a snapshot of the live DOM for restore visits, so an open menu would be baked into
// it `open` and come back open on Back. Close them before the snapshot is taken (same pattern as
// lib/tooltips.js). Turbo-frame re-renders need no handling: the server-rendered frame carries no
// `open` attribute, so the menu collapses naturally.
document.addEventListener("turbo:before-cache", () => closeMenus(null))
